// @ts-ignore
import getCountryValue from '../../../lib/utils/getCountryValue';

export const YandexCLType = 'yandex';
export const GoogleCLType = 'google';
export const OutlookCLType = 'outlook';

export const CLTypes = [YandexCLType, GoogleCLType, OutlookCLType];

export const getCLTypes = () => {
  const types = [GoogleCLType, OutlookCLType];

  const yandexValue = getCountryValue({ ru: YandexCLType });
  yandexValue && types.unshift(yandexValue);

  return types;
}

export interface ICalendarEventsProps {
  startDate: string,
  endDate: string,
  startTime: string,
  endTime: string,
  name: string,
  className?: string,
}

export type TObjectHandler = (name: string, start: string, end: string) => JSX.Element